import '@mrhenry/wp--bugsnag-config';

import { MrBlockedContent, MrInputSink, MrMenu } from '@mrhenry/wp--mr-interactive';

import './modules/mr-navigation-overlay';

customElements.define( 'mr-blocked-content', MrBlockedContent );
customElements.define( 'mr-input-sink', MrInputSink );
customElements.define( 'mr-menu', MrMenu );
